import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

function formatarData(data) {
  if (!data) return '';

  return new Date(data).toLocaleDateString('pt-BR');
}

function formatarDataBR(data) {
  if (!data) return '';

  // evita problema com ISO e strings incompletas
  const [ano, mes, dia] = data.split('-');

  if (!ano || !mes || !dia) return data;

  return `${dia}/${mes}/${ano}`;
}

function obterStatus(status) {
  switch (Number(status)) {
    case 1:
      return 'PENDENTE';
    case 2:
      return 'ENTREGUE';
    case 3:
      return 'CANCELADO';
    default:
      return 'TODOS';
  }
}

export default function imprimirRelatorioPdf(
  encomendas,
  filtros
) {

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const totalGeral = encomendas.reduce(
    (acc, item) => acc + Number(item.TOTAL || 0),
    0
  );

  const tabela = [
    [
      { text: 'Nº Pedido', style: 'tableHeader' },
      { text: 'Data Pedido', style: 'tableHeader' },
      { text: 'Status', style: 'tableHeader' },
      { text: 'Valor', style: 'tableHeader', alignment: 'right' }
    ],

    ...encomendas.map((item, index) => [
      {
        text: item.DOCUMENTO,
        fillColor: index % 2 === 0 ? '#F8F9FA' : null
      },
      {
        text: formatarData(item.DATA_PEDIDO),
        fillColor: index % 2 === 0 ? '#F8F9FA' : null
      },
      {
        text: item.STATUS_DESC,
        fillColor: index % 2 === 0 ? '#F8F9FA' : null
      },
      {
        text: `R$ ${Number(item.TOTAL || 0).toFixed(2)}`,
        alignment: 'right',
        fillColor: index % 2 === 0 ? '#F8F9FA' : null
      }
    ])
  ];

  const docDefinition = {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [25, 25, 25, 30],

    content: [

      {
        table: {
          widths: ['*'],
          body: [[
            {
              text: 'RELATÓRIO DE ENCOMENDAS',
              alignment: 'center',
              fontSize: 20,
              bold: true,
              color: 'white',
              fillColor: '#343A40',
              margin: [0, 10, 0, 10]
            }
          ]]
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 15]
      },

      {
        text: 'FILTROS UTILIZADOS',
        style: 'sectionTitle'
      },

      {
        table: {
          widths: ['*', '*'],
          body: [
            [
              {
                text: filtros.usaDataPedido
                  ? `Data Pedido: ${formatarDataBR(filtros.dataPedidoInicial)} até ${formatarDataBR(filtros.dataPedidoFinal)}`
                  : 'Data Pedido: Todos'
              },
              {
                text: filtros.usaDataEntrega
                  ? `Data Entrega: ${formatarDataBR(filtros.dataEntregaInicial)} até ${formatarDataBR(filtros.dataEntregaFinal)}`
                  : 'Data Entrega: Todos'
              }
            ],
            [
              {
                text: `Status: ${obterStatus(filtros.status)}`,
                colSpan: 2
              },
              {}
            ]
          ]
        },
        margin: [0, 0, 0, 15]
      },

      {
        text: 'ENCOMENDAS',
        style: 'sectionTitle'
      },

      {
        table: {
          headerRows: 1,
          widths: [70, 90, '*', 80],
          body: tabela
        },
        layout: {
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          hLineColor: () => '#D0D0D0',
          vLineColor: () => '#D0D0D0'
        }
      },

      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ['*', 120],
          body: [
            [
              {
                text: 'TOTAL GERAL',
                bold: true,
                alignment: 'right'
              },
              {
                text: `R$ ${totalGeral.toFixed(2)}`,
                bold: true,
                alignment: 'right',
                fillColor: '#E9ECEF'
              }
            ]
          ]
        }
      }

    ],

    footer(currentPage, pageCount) {
      return {
        columns: [
          {
            text: `Emitido em ${new Date().toLocaleString('pt-BR')}`,
            margin: [25, 0, 0, 0],
            fontSize: 8
          },
          {
            text: `${currentPage}/${pageCount}`,
            alignment: 'right',
            margin: [0, 0, 25, 0],
            fontSize: 8
          }
        ]
      };
    },

    styles: {
      sectionTitle: {
        fontSize: 13,
        bold: true,
        margin: [0, 0, 0, 8]
      },

      tableHeader: {
        fillColor: '#343A40',
        color: 'white',
        bold: true,
        alignment: 'center'
      }
    }
  };

  pdfMake.createPdf(docDefinition).open();
}